<div id="frtBOLfinalizationInformation">
  @if (finalization$ | async) {
    <form [formGroup]="frtBolFinalizationForm">
      <div class="grid-row grid-gap-1">
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
          <label for="estimatedCharges" class="usa-label text-bold">Total Estimated Charges: </label>
          <label id="estimatedCharges" class="usa-label">{{totalCost | currency}}</label>
        </div>
        @if (this.billOfLadingNbr != null && this.billOfLadingNbr != '') {
          <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
            <label for="authorityForCorrection" class="usa-label text-bold">Authority For Correction : (Maximum 150 chars)</label>
            <input type="text" maxlength="150" id="authorityForCorrection" class="maxw-full usa-input" formControlName="authorityForCorrection" />
          </div>
        }
      </div>
      <div class="grid-row grid-gap-1">
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-6 desktop:grid-col-6">
          <label for="marksAnnotationsAdditionalInfo" class="usa-label text-bold">Marks and Annotations/Additional Shipping
          Information:(Maximum 1000 chars) </label>
          <textarea id="marksAnnotationsAdditionalInfo" type="text" id="additionalRemarks" rows="8" maxlength="1000" class="maxw-full usa-textarea" formControlName="additionalRemarks" value={{additionalRemarks}}></textarea>
        </div>
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-6 desktop:grid-col-6"></div>
        @if (this.billOfLadingNbr != null && this.billOfLadingNbr != '') {
          <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-6 desktop:grid-col-6">
            <label for="correctionRemarks" class="usa-label text-bold">Additional Remarks For Correction Notice : (Maximum 200
            chars)</label>
            <textarea type="text" maxlength="200" id="correctionRemarks" rows="4" class="usa-textarea maxw-full" formControlName="correctionRemarks"></textarea>
          </div>
        }
      </div>
    </form>
  }
</div>
